import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { formGroupRadioDefaultProps, formGroupRadioPropTypes } from "../FormGroupCommonPropTypes";
import CommonWrapper from "../Wrappers/CommonWrapper";
import RenderErrors from "./RenderErrors";
import { showErrors } from "../commonFunctions";
var RenderRadio = function RenderRadio(_ref) {
  var input = _ref.input,
    label = _ref.label,
    classConfig = _ref.classConfig,
    value = _ref.value,
    _ref$meta = _ref.meta,
    touched = _ref$meta.touched,
    error = _ref$meta.error,
    wrapperClassName = _ref.wrapperClassName,
    disabled = _ref.disabled,
    muteError = _ref.muteError;
  var show = !muteError && showErrors(touched, error);
  return /*#__PURE__*/React.createElement(CommonWrapper, {
    wrapperClassName: wrapperClassName,
    showErrors: show
  }, /*#__PURE__*/React.createElement("label", {
    // eslint-disable-line jsx-a11y/label-has-associated-control
    className: classConfig.label
  }, /*#__PURE__*/React.createElement("input", _extends({}, input, {
    value: value,
    className: classConfig.input,
    checked: input.value === value,
    type: "radio",
    disabled: disabled
  })), label), /*#__PURE__*/React.createElement(RenderErrors, {
    showErrors: show,
    error: error
  }));
};
RenderRadio.propTypes = _objectSpread({}, formGroupRadioPropTypes);
RenderRadio.defaultProps = _objectSpread({}, formGroupRadioDefaultProps);
export default RenderRadio;